import React, { Fragment, useEffect, useState } from 'react';
import { Modal, Form, Col, Row, Input, Button, Select, Table, Alert, message, Popconfirm, Switch } from 'antd';
import { getGlobalMessages, createGlobalMessage, removeGlobalMessage } from '../api';

function GlobalMessages(props: any) {
	const { organizationId } = props;
	const [modalVisible, setModalVisible] = useState(false);
	const [saving, setSaving] = useState(false);
	const [loading, setLoading] = useState(false);
	const [messages, setMessages] = useState([]);

	const [form] = Form.useForm();

	async function fetchGlobalMessages() {
		setLoading(true);
		try {
			const resp = await getGlobalMessages(organizationId);
			setMessages(resp);
		} catch (err) {
			message.error('Something went wrong, cannto get global messages');
		}

		setLoading(false);
	}

	useEffect(() => {
		fetchGlobalMessages();
	}, []);

	useEffect(() => {
		form.resetFields();
	}, [modalVisible]);

	async function onAddGlobalMessage(payload: any) {
		try {
			setSaving(true);
			await createGlobalMessage(payload);

			await fetchGlobalMessages();

			setModalVisible(false);
			setSaving(false);
		} catch (err) {
			setSaving(false);
			message.error('Something went wrong, cannot add message');
		}
	}

	async function onDelete(id: string) {
		try {
			setSaving(true);
			await removeGlobalMessage(organizationId, id);

			await fetchGlobalMessages();

			setModalVisible(false);
			setSaving(false);
		} catch (err) {
			setSaving(false);
			message.error('Something went wrong, cannot remove message');
		}
	}

	function saveForm(values: any) {
		values.organization_id = organizationId;
		onAddGlobalMessage(values);
	}

	const columns = [
		{
			title: 'Title',
			dataIndex: 'title',
			key: 'title',
		},
		{
			title: 'Text',
			dataIndex: 'text',
			key: 'text',
		},
		{
			title: 'Type',
			dataIndex: 'type',
			key: 'type',
		},
		{
			title: 'Remove on close',
			dataIndex: 'closeable',
			key: 'closeable',
			render: (text: string) => (text ? 'YES' : 'NO'),
		},
		{
			title: '',
			dataIndex: 'actions',
			key: 'actions',
			render: (text: string, record: any) => (
				<Popconfirm
					placement="topRight"
					title="Do you really want to remove this message?"
					onConfirm={() => onDelete(record.id)}
				>
					<a>remove</a>
				</Popconfirm>
			),
		},
	];

	return (
		<Fragment>
			<Button onClick={() => setModalVisible(true)} type="primary">
				Add new message
			</Button>
			<Table dataSource={messages} loading={loading} rowKey="id" columns={columns} />
			<Modal
				okText="Save"
				cancelText="Cancel"
				title={'Add global message'}
				okButtonProps={{ loading: saving }}
				visible={modalVisible}
				onOk={() => form.submit()}
				destroyOnClose={true}
				onCancel={() => setModalVisible(false)}
			>
				<Form form={form} id="globalMessageForm" onFinish={saveForm} layout="vertical">
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item name="title" label="Title" rules={[{ required: true, message: 'Add title' }]}>
								<Input placeholder="Title" />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="text" label="Text" rules={[{ required: true, message: 'Add text' }]}>
								<Input placeholder="Text" />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="type" initialValue="info" label="Type">
								<Select size="large">
									<Select.Option value="success">
										<Alert banner message="Success Text" type="success" />
									</Select.Option>
									<Select.Option value="info">
										<Alert banner message="Info Text" type="info" />
									</Select.Option>
									<Select.Option value="warning">
										<Alert banner message="Warning Text" type="warning" />
									</Select.Option>
									<Select.Option value="error">
										<Alert banner message="Error Text" type="error" />
									</Select.Option>
								</Select>
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item
								name="closeable"
								valuePropName="checked"
								initialValue={true}
								label="Remove on close"
							>
								<Switch />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>
		</Fragment>
	);
}

export default GlobalMessages;
